import React from "react";
import Modal from "../ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useNavigate } from "react-router-dom";
import Button from "../Button";
import SectionHeader from "@components/SectionHeader";
import ErrorPageIcon from "@assets/page-error.svg?react";
import "./style.scss";
import { useQuery } from "@tanstack/react-query";
import {
  DETAILS_CACHE_TIME,
  DETAILS_REFETCH_INVERVAL,
  DETAILS_STALE_TIME,
  getUserDetails,
} from "../../api/consumer";
import { removeUrlParam } from "../../UrlParamsHelper";
import { fetchData } from "@app/Helpers";

export default NiceModal.create(() => {
  const modal = useModal();
  const navigate = useNavigate();

  if (modal?.args?.updateUserData) {
    const detailsQuery = useQuery({
      queryKey: ["user-details"],
      queryFn: () => getUserDetails(),
      refetchInterval: DETAILS_REFETCH_INVERVAL,
      staleTime: DETAILS_STALE_TIME,
      cacheTime: DETAILS_CACHE_TIME,
    });

    detailsQuery.refetch();
  }

  function removeToken() {
    fetchData({
      endpoint: "/consumer/logout",
      payload: {},
      successCallback: () => {
        removeCookie("ICToken");
        localStorage.removeItem("token");
        localStorage.removeItem("loginEvent");
        localStorage.removeItem("urlParams");
        localStorage.removeItem("identify");
        sessionStorage.removeItem("passportData");
        sessionStorage.removeItem("halloween2025_start");
        sessionStorage.removeItem("hideEasterEggBar");
        sessionStorage.removeItem("foundEggs");
        sessionStorage.removeItem("sId");
        sessionStorage.removeItem("loginSource");
        navigate("/logout");
      },
      errorCallback: () => {
        removeCookie("ICToken");
        localStorage.removeItem("token");
        localStorage.removeItem("identify");
        localStorage.removeItem("loginEvent");
        localStorage.removeItem("urlParams");
        sessionStorage.removeItem("passportData");
        sessionStorage.removeItem("halloween2025_start");
        sessionStorage.removeItem("hideEasterEggBar");
        sessionStorage.removeItem("foundEggs");
        sessionStorage.removeItem("sId");
        sessionStorage.removeItem("loginSource");
        navigate("/logout");
      },
    });
  }

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        if (modal?.args?.logout) removeToken();
        if (modal?.args?.returnUrl) {
          navigate(`${modal?.args?.returnUrl}`);
        }
        modal.hide();
      }}
      onAfterClose={() => modal.remove()}
      disableClose={modal?.args?.disableClose ?? true}
      innerClass={"error-modal"}
    >
      <SectionHeader pageHeader>
        Ups <strong>Etwas ist schief gelaufen.</strong>
      </SectionHeader>
      <div className="inner-content">
        <h3 className="upper">{modal?.args?.title ?? ""}</h3>
        <p className="sub">{modal?.args?.desc ?? ""}</p>
        <div className="error-code">
          <ErrorPageIcon />
          <p className="error">Error no. {modal?.args?.code ?? ""}</p>
        </div>
        <Button
          action={() => {
            modal.hide();
            if (modal?.args?.returnUrl) navigate(`${modal?.args?.returnUrl}`);
            if (modal?.args?.logout) removeToken();
          }}
        >
          {modal?.args?.button ?? ""}
        </Button>
      </div>
    </Modal>
  );
});
